import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import ButtonWithIcon from "src/v2/components/Button/Button"
import { ReactComponent as PlusIcon } from "src/v2/assets/icons/plus-square-icon.svg"
import { Box, ThemeProvider } from "@mui/material"
import GenericModal from "src/v2/components/modal/generic-modal"
import { ReactComponent as CheckIcon } from "src/v2/assets/icons/check-icon.svg"
import { ReactComponent as CloseIcon } from "src/v2/assets/icons/close-square-icon.svg"
import { ReactComponent as TrashIcon } from "src/v2/assets/icons/trash-icon.svg"
import UploadComponent from "src/v2/components/upload/upload-component"
import RadioButtonAccessLevel from "src/v2/components/radio-button/radio-button-access-level"
import TextFieldInput from "src/v2/components/Input/text-field-input"
import DataGridTable from "src/v2/components/Table/data-grid-table"
import themeLegacy from "src/utils/theme"
import DuplaConfirmacaoModal from "src/v2/components/DuplaConfirmacao/DuplaConfirmacao"

const Documents = ({
    cetip,
    isAdmin,
    documentService,
    setIsLoading,
    useTableHook, // Prop que recebe a função do Hook customizado desejado
}) => {
    const [isOpenModalSendFile, setOpenModalSendFile] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [value, setValue] = useState("")
    const [accessLevel, setAccessLevel] = useState("PRIVATE")

    const handleCloseModal = () => {
        setValue("")
        setSelectedFile(null)
        setOpenModalSendFile(false)
    }

    // Executa o hook dinamicamente passado por prop
    const { state, actions } = useTableHook(
        cetip,
        isAdmin,
        documentService
    )

    useEffect(() => {
        if (actions?.loadTable) {
            actions.loadTable()
        }
    }, [cetip])

    useEffect(() => {
        if (setIsLoading) {
            setIsLoading(state.loading)
        }
    }, [state.loading])

    const btnFileRef = useRef(null)
    const handleOpenModalSendFile = () => {
        setOpenModalSendFile(true)
    }

    return (
        <>
            {isAdmin && (
                <GenericModal
                    isOpen={isOpenModalSendFile}
                    title="Upload de arquivo"
                    onClose={handleCloseModal}
                    width="400px"
                >
                    <Box
                        sx={{
                            display: "flex",
                            width: "100%",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 3,
                            p: 3,
                        }}
                    >
                        <TextFieldInput
                            label="Nome do arquivo"
                            fullWidth
                            onChange={(e) => setValue(e.target.value)}
                            value={value}
                        />

                        <RadioButtonAccessLevel
                            value={accessLevel}
                            onChange={(event) => {
                                setAccessLevel(event.target.value)
                            }}
                        />

                        <UploadComponent
                            fileInputRef={btnFileRef}
                            onFileSelect={(event) => {
                                setSelectedFile(event)
                            }}
                        />
                        <Box
                            sx={{
                                display: "flex",
                                width: "100%",
                                whiteSpace: "nowrap",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                gap: 3,
                            }}
                        >
                            <ButtonWithIcon
                                size={"sm"}
                                icon={<CloseIcon />}
                                onClick={handleCloseModal}
                            >
                                CANCELAR
                            </ButtonWithIcon>
                            <ButtonWithIcon
                                size={"sm"}
                                icon={<CheckIcon />}
                                onClick={async () => {
                                    if (!selectedFile) return

                                    try {
                                        await actions.addDocument(
                                            accessLevel,
                                            value || selectedFile.name,
                                            selectedFile
                                        )
                                        handleCloseModal()

                                        await actions.loadTable()
                                    } catch (e) {
                                        console.error("error", e)
                                    }
                                }}
                            >
                                ENVIAR
                            </ButtonWithIcon>
                        </Box>
                    </Box>
                </GenericModal>
            )}
            <Box sx={{ display: "flex", gap: 3, flexDirection: "column" }}>
                {isAdmin && (
                    <Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
                        <ButtonWithIcon
                            onClick={handleOpenModalSendFile}
                            icon={<PlusIcon />}
                        >
                            ENVIAR DOCUMENTO
                        </ButtonWithIcon>
                    </Box>
                )}

                <DataGridTable
                    rows={state.rows}
                    columns={state.columns}
                    loading={state.loading}
                />
            </Box>
            {isAdmin && (
                <ThemeProvider theme={themeLegacy}>
                    <DuplaConfirmacaoModal
                        open={state.modalDelete?.isOpen}
                        cancel={state.modalDelete?.onExit}
                        confirm={state.modalDelete?.onConfirm}
                        title="Excluir"
                        description="Certifique-se que quer excluir esse item."
                        confirmTextButton="EXCLUIR"
                        cancelIcon={
                            <CloseIcon
                                style={{
                                    width: 22,
                                    height: 22,
                                    color: "#E3A404",
                                }}
                            />
                        }
                        confirmIcon={
                            <TrashIcon
                                style={{
                                    width: 22,
                                    height: 22,
                                    color: "#E3A404",
                                }}
                            />
                        }
                    />
                </ThemeProvider>
            )}
        </>
    )
}

Documents.propTypes = {
    cetip: PropTypes.string,
    isAdmin: PropTypes.bool.isRequired,
    documentService: PropTypes.any,
    setIsLoading: PropTypes.any,
    useTableHook: PropTypes.func.isRequired,
}

export default Documents